import { render, staticRenderFns } from "./TabCustom.vue?vue&type=template&id=6ddf8af6&scoped=true"
import script from "./TabCustom.vue?vue&type=script&lang=ts"
export * from "./TabCustom.vue?vue&type=script&lang=ts"
import style0 from "./TabCustom.vue?vue&type=style&index=0&id=6ddf8af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddf8af6",
  null
  
)

export default component.exports